import BenevvTextField from 'components/forms/BenevvTextField/BenevvTextField';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import * as AuthServiceApi from "apis/AuthServiceApi";
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

// colors
// #FE2F67

// styled components here
const Background = styled.div`
background-color: #E5E5E5; 
height: 100%;
min-height: 600px;
width: 100%;
`

const MainContent = styled.div`
font-family: 'Inter';

width: 80%;
max-width: 800px;
min-width: 350px;

height: 60%;
min-height: 475px;

margin-top: 100px;
margin-bottom: 100px;
margin-left: auto;
margin-right: auto;

background-color: #fff;

box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
border-radius: 6px;

display: flex;
flex-direction: column;
align-items: center;

h1 {
  margin-top: 50px;
  margin-bottom: 15px;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 39px;

  border-bottom: 3px solid #FE2F67;
}

label {
  font-weight: 600;
  font-size: .9em;
}

input {
  margin-top: 3px;
  margin-bottom: 25px;

  padding: 3px;

  border-radius: 3px;
  border: 1px solid #8F8F8F;
}

button {
  padding: 11px;

  margin-bottom: 25px;

  border: none;
  border-radius: 6px;

  font-size: .9em;
  font-weight: 600;
  font-family: 'Inter';
  color: #fff;
  background-color: #FE2F67;

  cursor: pointer;
}

.pMatchErrorVisible {
  color: #ff0000;
}

.pMatchErrorNotVisible {
  display: none;
}

`

function ResetPassword () {
  return (
    <>
     
      <Background>
    
        <DisplayMainContent />

      </Background>

    </>
  )
 
}

function BackgroundColor () {
  return (
    <Background></Background>
  )
}

function DisplayMainContent () {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [doPasswordsMatch, setDoPasswordsMatch] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token")!

  // logic for passwords do not match error
  let passwordsDoNotMatch;

  if(doPasswordsMatch) {
    passwordsDoNotMatch = ( <p className="pMatchErrorNotVisible">Passwords do not match</p> );
  } else {
    passwordsDoNotMatch = ( <p className="pMatchErrorVisible">Passwords do not match</p> );
  }
 
  // this component has client-side password validation, which could be altered by malicious actor, Server-side validation should be implemented as well...

  const handleChangePassword = (event: any) => {
    setPassword(event.target.value);
  };

  const handleChangeConfirmPassword = (event: any) => {
    setConfirmPassword(event.target.value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const resetPassword = await AuthServiceApi.verifyResetPassword({
      email: email,
      token: token,
      New_password: password
    })

    navigate("/org/home")
  }

  const verifyPasswordsMatch = (event: any) => {
    
    if(password === confirmPassword){
      setDoPasswordsMatch(true);
    } else {
      event.preventDefault();
      
      setDoPasswordsMatch(false);

      console.log("Passwords do not match");
    }
  }


  
  return (
    <> 
      <MainContent>

        <h1>Reset Password</h1>

        <ul>
          Must use at least:
          <li>One Uppercase Letter A-Z</li>
          <li>One Lowercase Letter a-z</li>
          <li>One Number 0-9</li>
          <li>One Special Character</li>
        </ul>

        <br  />

        <form onSubmit={handleSubmit}>
          <br/>
          <input type="hidden" name="token" value={token} />
        <BenevvTextField htmlFor={'email'} labelText={'Email address*'} placeholder={'Enter email address'}
                             required={true} setTextField={setEmail}/>
          <label>
            Password
          </label>

          <br />

          <input
              name="password"
              type="password"
              pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[.?!$&@#%\s]).{8,}"
              required
              onChange={handleChangePassword}
              
            />
          
          <br />
          
          <label>
            Re-type Password
          </label>

          <br />

          <input
              name="passwordVerify"
              type="password"
              pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[.?!$&@#%\s]).{8,}"
              required
              onChange={handleChangeConfirmPassword}
              
            />

            <br />

            {passwordsDoNotMatch}

            <br />
            
            <br />

          <button 
          type="submit"
          onClick={verifyPasswordsMatch}
          >Reset Password</button>

        </form>
      </MainContent>

    </>
  )
}

export default ResetPassword;